module.exports = __webpack_public_path__ + "static/media/fidelitybank.7fd8539e.svg";